import { useMutation } from '@tanstack/react-query'
import ApiClient from '@/domains/shared/hooks/ApiClient'
import { announceSignOut } from '@/domains/shared/hooks/authBroadcast'
import Session from '@/domains/shared/hooks/Session'

export const useLogout = () => {
  return useMutation({
    mutationFn: async () => {
      // The browser sends the session cookie; the API deletes that session and
      // expires the cookie.
      await ApiClient.post('/auth/logout')
    },
    meta: { skipGlobalErrorToast: true },
    onSettled: () => {
      // Clear local state regardless of whether the API call succeeded
      Session.remove()
      // Every other tab of this browser shared the session; they reload too.
      announceSignOut()
      globalThis.location.href = '/'
    },
  })
}
